import {
  CONSULTAMEDTURNOS_SUCCESS,
  CONSULTAMEDTURNOS_LOADING,
  CONSULTAMEDTURNOS_ERROR,
  CONSULTAMEDTURNOS_LOGOUT,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";

export const wsGetVerificaConsultaMedica =
  (especialidad, medico, nextStep) => (dispatch) => {
    dispatch({ type: CONSULTAMEDTURNOS_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(`/consulta_medica/verificar_os_Qr/${especialidad}/${medico}`)
        .then((resp) => {
          dispatch({
            type: CONSULTAMEDTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };
          dispatch({ type: CONSULTAMEDTURNOS_ERROR, payload: error });
          if (nextStep) nextStep(false, error);
        });
    });
  };

export const wsPostConsultaMedTurnos =
  (
    especialidad,
    agenda,
    fecha,
    particular,
    vc,
    idPacFamiliar,
    osAlternativa,
    nextStep
  ) =>
  (dispatch) => {
    dispatch({ type: CONSULTAMEDTURNOS_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(
          `/consulta_medica/turnosDisponiblesQr/${especialidad}/${agenda}/${fecha}/${particular}/${vc}/${
            !idPacFamiliar ? "" : idPacFamiliar
          }/${!osAlternativa ? "" : osAlternativa}`
        )
        .then((resp) => {
          dispatch({
            type: CONSULTAMEDTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: CONSULTAMEDTURNOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

export const wsPostTomarTurnoConsultaMed =
  (requestBody, idPariente, nextStep) => (dispatch) => {
    dispatch({ type: CONSULTAMEDTURNOS_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .post(
          `/consulta_medica/turnoQr/${!idPariente ? "" : idPariente}`,
          requestBody
        )
        .then((resp) => {
          dispatch({
            type: CONSULTAMEDTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: CONSULTAMEDTURNOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

export const logoutConsultaMedTurnos = () => (dispatch) => {
  dispatch({ type: CONSULTAMEDTURNOS_LOGOUT });
};
